import { Component, OnInit, EventEmitter } from '@angular/core';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ProductoService } from '../producto.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductoViewComponent } from '../producto-view/producto-view.component';

@Component({
  selector: 'app-producto-stock-critico',
  templateUrl: './producto-stock-critico.component.html',
  styleUrls: ['./producto-stock-critico.component.scss']
})
export class ProductoStockCriticoComponent implements OnInit {

  url_stock_critico_productos: string = '';
  url_stock_critico_insumos: string = '';

  reloadEmitter: EventEmitter<string> = new EventEmitter();

  filtros = [
    {
      label: 'Nombre',
      column: '$producto.nombre$',
      op: 'substring'
    },
    {
      label: 'Stock',
      column: 'cantidad',
      type: 'number',
    }
  ]

  columnas = [
    {
      label: 'Nombre',
      attribute: 'producto',
      width: 1,
      responsive: ['XS', 'SM', 'MD'],
      value: (element: any) => {
        return element.producto.nombre
      }
    },
    {
      label: 'Stock',
      attribute: 'cantidad',
      width: 1,
      responsive: ['SM', 'MD'],
      value: (element: any) => {
        return element.cantidad
      }
    },
    {
      label: 'Stock Faltante',
      attribute: 'faltante',
      width: 1,
      responsive: ['SM', 'MD'],
      value: (element: any) => {
        return this.formatter.numberFormat(element.stock_faltante)
      }
    },
    {
      label: 'Costo',
      attribute: 'costo',
      width: 1,
      responsive: ['SM', 'MD'],
      value: (element: any) => {
        return '$ ' + this.formatter.numberFormat(element.costo_stock_faltante)
      }
    }
  ]

  acciones: any[] = [

    {
      label: 'Detalle',
      icon: 'eye',
      action: (element: any, index: number) => {
        this.view(element.producto.id);
      }
    }
  ]

  constructor(
    public config: ConfigService,
    public loading: LoadingService,
    private alerts: AlertService,
    public formatter: FormatterService,
    public service: ProductoService,
    public sesion: SesionService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.url_stock_critico_productos = this.config.apiUrl + this.service.controller + 'stock-critico';
  }


  loadData(): void {
    this.reloadEmitter.emit();
  }

  view(id: number) {
    this.loading.show()
    this.service.setID(id)
    this.service.view(id).subscribe((res: any) => {
      this.loading.hide();
      const modalRef = this.modalService.open(ProductoViewComponent, { size: 'lg', scrollable: true });
      modalRef.componentInstance.element = res
      modalRef.result.then((result) => { }, (reason) => { });
    })
  }

}
